import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api';

const Licenses: React.FC = () => {
  const navigate = useNavigate();
  const [selectedApp, setSelectedApp] = useState('license_reclaim');

  const { data: installsData, isLoading } = useQuery({
    queryKey: ['installs-list', selectedApp],
    queryFn: async () => {
      const response = await apiClient.get<any>(`/api/installs-list?app=${selectedApp}&limit=100`);
      return response;
    },
  });

  const installs = installsData?.items || [];

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-gray-500">Loading installs...</div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Installs</h1>
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">Filter by Application</label>
        <select
          value={selectedApp}
          onChange={(e) => setSelectedApp(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="license_reclaim">LicenseReclaim</option>
          <option value="orbit">Orbit</option>
          <option value="doc_route">DocRoute</option>
        </select>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Company</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Admin Email</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Install ID</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Salesforce Org</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Installed</th>
              <th className="px-6 py-3 text-right text-sm font-semibold text-gray-900"></th>
            </tr>
          </thead>
          <tbody>
            {installs.length === 0 ? (
              <tr>
                <td colSpan={6} className="px-6 py-8 text-center text-gray-500">
                  No active installs for this application.
                </td>
              </tr>
            ) : (
              installs.map((install: any) => (
                <tr key={install.installId} className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm font-medium text-gray-900">{install.companyName}</td>
                  <td className="px-6 py-4 text-sm text-gray-700">{install.adminEmail}</td>
                  <td className="px-6 py-4 text-sm font-mono text-gray-600">
                    <code className="bg-gray-100 px-2 py-1 rounded text-xs">{install.installId.slice(0, 8)}</code>
                  </td>
                  <td className="px-6 py-4 text-sm font-mono text-gray-600">
                    {install.sfOrgId ? (
                      <code className="bg-gray-100 px-2 py-1 rounded text-xs">{install.sfOrgId.slice(0, 8)}</code>
                    ) : (
                      <span className="text-gray-400">—</span>
                    )}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-600">
                    {install.createdAt ? new Date(install.createdAt * 1000).toLocaleDateString() : '—'}
                  </td>
                  <td className="px-6 py-4 text-right">
                    <button
                      onClick={() => navigate(`/installs/${install.installId}`)}
                      className="text-blue-600 hover:text-blue-800 text-sm font-medium"
                    >
                      Manage →
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Licenses;
